import bee from "./Bee"
export default {
    name: "Directory",
    get_pagination_stats_of_alpha(query, success, fail){
        bee.get({
            businesses:{
                _a: " _count ",
                _w: [
                    ["name","sw",query.alpha]
                ]
            }
        }).then(res => {
            if (success) {
                success(res.businesses[0].count);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    get_businesses_starting_wih_alpha(query, success, fail){
        // num_available: 0
        // number_loaded: 0
        // page: 1
        // page_size: 10
        // alpha

        bee.get({
            businesses:{
                district: {},
                business_holliday_schedules:{},
                _ob: ["name"],
                _pg: query.page_size + "." + query.page,
                _w: [
                    ["name","sw",query.alpha]
                ]
            },
            _box: {
                ...query
            }
        }).then(res => {
            //console.log("Here we are", res);
            if (success) {
                success(res);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    }
}